var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.019 17.2256C23.1642 17.2256 19.2286 21.1613 19.2286 26.0161C19.2286 30.871 23.1642 34.8066 28.019 34.8066C32.8739 34.8066 36.8095 30.871 36.8095 26.0161C36.8095 21.1613 32.8739 17.2256 28.019 17.2256ZM17 26.0161C17 19.9305 21.9334 14.9971 28.019 14.9971C34.1047 14.9971 39.0381 19.9305 39.0381 26.0161C39.0381 32.1018 34.1047 37.0352 28.019 37.0352C21.9334 37.0352 17 32.1018 17 26.0161Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4946 32.4914C34.9297 32.0563 35.6353 32.0563 36.0704 32.4914L43.5 38.4968C44 38.9968 44 39.9968 43 40.9968C42 41.9968 40.9352 41.9319 40.5 41.4968L34.4946 34.0672C34.0594 33.6321 34.0594 32.9266 34.4946 32.4914Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6695 30.8467C37.2838 30.8833 37.7522 31.4109 37.7156 32.0253C37.6568 33.0139 37.4589 33.9722 36.7504 34.6741C36.0626 35.3555 35.098 35.586 34.0951 35.7066C33.4841 35.7801 32.9292 35.3444 32.8557 34.7334C32.7823 34.1224 33.218 33.5675 33.829 33.494C34.7583 33.3822 35.0596 33.2121 35.182 33.0909C35.2836 32.9902 35.4403 32.7441 35.491 31.8928C35.5276 31.2785 36.0552 30.8102 36.6695 30.8467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cc2f009bc8833a954ac39b2bac05fae0.svg";
export { ForwardRef as ReactComponent };